module.exports = "/dist/images/55ef7c7d9cb4f65c840dc25b5fda93a1-nonveg.png";